class ProfilePopup extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      button: this.querySelector('button'),
      panel: this.querySelector('.profile-popup-wrap'),
    };
    this.elements.button.addEventListener('click', this.openSelector.bind(this));
    this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
  }

  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', true);
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    this.hidePanel();
  }

  openSelector() {
    this.elements.button.focus();
    this.elements.panel.toggleAttribute('hidden');
    this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
  }

  closeSelector(event) {
    const shouldClose = event.relatedTarget === null || event.relatedTarget.dataset.accountPopupItem === "";
    if (!shouldClose) {
      this.hidePanel();
    } else {
      this.elements.button.focus();
    }
  }
}

customElements.define('profile-popup', ProfilePopup);
